import React, { useState, useEffect } from "react";

import { API, graphqlOperation } from "aws-amplify";
import {
  createArea,
  updateArea,
  deleteArea,
  createZone,
  deleteZone,
  deleteLocation,
  deleteAisle,
  updateZone,
  updateAisle,
  updateLocation,
} from "../../../../graphql/mutations";
import { updateAuditInventorie } from "../../../../graphql/inventory/custom-mutations";
import {
  inventoryItemByAreaByStatusMini,
  searchInventorys,
} from "../../../../graphql/inventory/custom-queries";
import {
  aisleByActiveByAreaBySortKey,
  locationByAisleBySortKey,
  locationByAreaBySortKey,
} from "../../../../graphql/queries";

import { useNotify } from "react-admin";

import {
  Avatar,
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  makeStyles,
  MenuItem,
  TextField,
} from "@material-ui/core";

import LocationOnIcon from "@material-ui/icons/LocationOn";
import { AddIcon, DeleteIcon, EditIcon } from "../../../../components/common/iconography";
import { logError } from "../../../../utils/appUtils";
import {
  AreaType,
  AreaTypeOptions,
  InventoryStatus,
  LocationType,
  NoteType,
} from "../../../../utils/constants";
import {
  getLocationFullName,
  hasTrackCarsOnLocations,
} from "../../../../utils/locationUtils";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: theme.spacing(4),
    marginRight: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  addContainer: {
    display: "flex",
    justifyContent: "center",
  },
  avatar: {
    "&:hover": {
      cursor: "grab",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const Areas = ({ record, areas, aisles, getData }) => {
  const classes = useStyles();
  const notify = useNotify();
  const [addOpen, setAddOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [renameOpen, setRenameOpen] = React.useState(false);
  const [selectedArea, setSelectedArea] = useState();
  const [loading, setLoading] = useState();

  const openRenameDialog = (zone) => {
    setSelectedArea(zone);
    setRenameOpen(true);
  };

  const addArea = async (newArea) => {
    try {
      debugger;
      setLoading(true);
      newArea.active = "true";
      newArea.groups = record.groups;
      newArea.reloadYardId = record.id;
      newArea.prefix = newArea.prefix.toUpperCase();
      newArea.sortKey = areas?.length ? areas[areas.length - 1].sortKey + 1 : 1;

      const areaResp = await API.graphql(
        graphqlOperation(createArea, { input: newArea })
      );
      const defaultZone = {
        active: "true",
        groups: record.groups,
        reloadYardId: record.id,
        areaId: areaResp.data.createArea.id,
        name: "Default",
        prefix: "D",
        color: "#8bc34a",
        sortKey: 1,
      };
      await API.graphql(graphqlOperation(createZone, { input: defaultZone }));

      getData();
      setAddOpen(false);
      setSelectedArea(null);
    } catch (error) {
      logError("resources:reloadYard:Areas:addArea", error, notify);
    } finally {
      setLoading(false);
    }
  };

  const doUpdateAreas = async (areas) => {
    debugger;
    const results = await Promise.allSettled(
      areas.map((itm) => {
        const toUpdateArea = { ...itm };
        delete toUpdateArea.zones;
        delete toUpdateArea.createdAt;
        delete toUpdateArea.updatedAt;
        return API.graphql(
          graphqlOperation(updateArea, { input: toUpdateArea })
        );
      })
    );

    const resError = results.find((itm) => itm.status === "rejected");
    debugger;
    if (resError) {
      logError("reloadYard:Area:doUpdateAreas", resError, false);
      throw resError;
    }
  };

  const doUpdateInventories = async (area) => {
    debugger;
    const response = await API.graphql(
      graphqlOperation(searchInventorys, {
        filter: {
          reloadYardId: { eq: record.id },
          status: { eq: InventoryStatus.STORED },
          areaId: { eq: area.id },
        },
        limit: 1000,
      })
    );
    const data = response.data.searchInventorys.items;
    const results = await Promise.allSettled(
      data.map((inventory) => {
        const toUpdateInventory = { ...inventory };
        if (!inventory.location) return Promise.resolve();
        const newLocation = { ...inventory.location, area: area };
        toUpdateInventory.locationFullName = getLocationFullName(newLocation);
        const historyNote = {
          type: NoteType.INVENTORY,
          date: new Date(),
          by: window.appUser.fullName,
          text: `Location re-named from ${inventory.locationFullName} to ${toUpdateInventory.locationFullName}`,
        };
        toUpdateInventory.history = [...toUpdateInventory.history, historyNote];

        delete toUpdateInventory.location;
        delete toUpdateInventory.account;
        delete toUpdateInventory.product;
        delete toUpdateInventory.inboundShipment;
        delete toUpdateInventory.createdAt;
        delete toUpdateInventory.updatedAt;
        return API.graphql(
          graphqlOperation(updateAuditInventorie, { input: toUpdateInventory })
        );
      })
    );

    const resError = results.find((itm) => itm.status === "rejected");

    if (resError) {
      logError(
        "reloadYard:Areas::doUpdateInventories:response",
        resError,
        false
      );
      throw resError;
    }
  };

  const renameArea = async (area) => {
    if (!area) return;
    debugger;

    try {
      setLoading(true);
      area.prefix = area.prefix.toUpperCase();
      await doUpdateArea(area);
      await doUpdateInventories(area);
      getData();
      setSelectedArea(null);
      setRenameOpen(false);
      notify("Area updated succesfully.", "info");
    } catch (error) {
      logError("resources:reloadYard:Areas:renameArea", error, notify);
    } finally {
      setLoading(false);
    }
  };

  const doUpdateArea = async (area) => {
    debugger;
    const toUpdateArea = { ...area };
    delete toUpdateArea.zones;
    delete toUpdateArea.createdAt;
    delete toUpdateArea.updatedAt;
    debugger;
    await API.graphql(graphqlOperation(updateArea, { input: toUpdateArea }));
  };

  const doDeleteArea = async (area) => {
    const input = { id: area.id };
    await API.graphql(graphqlOperation(deleteArea, { input }));
  };

  const doUpdateZones = async (zones) => {
    debugger;
    const results = await Promise.allSettled(
      zones.map((itm) => {
        const toUpdateZone = { ...itm };
        delete toUpdateZone.createdAt;
        delete toUpdateZone.updatedAt;
        delete toUpdateZone.aisles;
        return API.graphql(
          graphqlOperation(updateZone, { input: toUpdateZone })
        );
      })
    );

    const resError = results.find((itm) => itm.status === "rejected");
    debugger;
    if (resError) {
      logError("reloadYard:Areas:doUpdateZones", resError, false);
      throw resError;
    }
  };

  const doDeleteZones = async (zones) => {
    const results = await Promise.allSettled(
      zones.map((zone) => {
        return API.graphql(
          graphqlOperation(deleteZone, { input: { id: zone.id } })
        );
      })
    );

    const resError = results.find((itm) => itm.status === "rejected");
    if (resError) {
      logError("reloadYard:Areas:doDeleteZones", resError, false);
      throw resError;
    }
  };

  const doUpdateLocations = async (toUpdateLocations) => {
    debugger;
    const results = await Promise.allSettled(
      toUpdateLocations.map((itm) => {
        const toUpdateLocation = {
          ...itm,
          productId: itm.productId ? itm.productId : "",
        };
        delete toUpdateLocation.aisle;
        delete toUpdateLocation.area;
        delete toUpdateLocation.createdAt;
        delete toUpdateLocation.tags;
        delete toUpdateLocation.updatedAt;
        delete toUpdateLocation.zone;

        return API.graphql(
          graphqlOperation(updateLocation, { input: toUpdateLocation })
        );
      })
    );

    const resError = results.find((itm) => itm.status === "rejected");

    if (resError) {
      logError("reloadYard:areas:doUpdateLocations", resError, false);
      throw resError;
    }
  };

  const doDeleteLocations = async (areaId) => {
    debugger;
    const locationResponse = await API.graphql(
      graphqlOperation(locationByAreaBySortKey, {
        reloadYardId: record.id,
        areaIdSortKey: { beginsWith: { areaId: areaId } },
      })
    );
    const toDeleteLocations =
      locationResponse.data.locationByAreaBySortKey.items;
    const promiseList = toDeleteLocations.map((location) => {
      debugger;
      return API.graphql(
        graphqlOperation(deleteLocation, { input: { id: location.id } })
      );
    });

    const results = await Promise.allSettled(promiseList);
    const resError = results.find((itm) => itm.status === "rejected");

    if (resError) {
      logError("reloadYard:Areas:doDeleteLocations", resError, false);
      throw resError;
    }
  };

  const doUpdateAisles = async (toUpdateAisles) => {
    const results = await Promise.allSettled(
      toUpdateAisles.map((itm) => {
        const toUpdateAisle = { ...itm };
        delete toUpdateAisle.area;
        delete toUpdateAisle.createdAt;
        delete toUpdateAisle.locations;
        delete toUpdateAisle.updatedAt;
        delete toUpdateAisle.zone;
        return API.graphql(
          graphqlOperation(updateAisle, { input: toUpdateAisle })
        );
      })
    );

    const resError = results.find((itm) => itm.status === "rejected");

    if (resError) {
      logError("reloadYard:Areas:doUpdateAisles", resError, false);
      throw resError;
    }
  };

  const doDeleteAisles = async (areaId) => {
    const aisleResponse = await API.graphql(
      graphqlOperation(aisleByActiveByAreaBySortKey, {
        areaId: areaId,
        activeSortKey: { beginsWith: { active: "true" } },
        limit: 1000,
      })
    );
    const toDeleteAisles =
      aisleResponse.data.aisleByActiveByAreaBySortKey.items;
    const promiseList = toDeleteAisles.map((aisle) => {
      debugger;
      return API.graphql(
        graphqlOperation(deleteAisle, { input: { id: aisle.id } })
      );
    });
    const results = await Promise.allSettled(promiseList);
    const resError = results.find((itm) => itm.status === "rejected");

    if (resError) {
      logError("reloadYard:Areas:doDeleteLocations", resError, false);
      throw resError;
    }
  };

  const disableDelete = () => {
    return areas?.length === 1;
  };

  const openDeleteDialog = (area) => {
    setSelectedArea(area);
    setDeleteOpen(true);
  };

  const handleDeleteArea = (area) => {
    if (disableDelete()) {
      notify("Must have at least 1 Area.", "warning");
    } else {
      openDeleteDialog(area);
    }
  };

  const collectAreaTrackLocationIds = (area) => {
    if (!area) return [];
    const zoneIds = (area.zones?.items || []).map((zone) => zone.id);
    const areaAisles = aisles.filter((aisle) =>
      zoneIds.includes(aisle.zoneId)
    );
    const trackIds = [];
    areaAisles.forEach((aisle) => {
      (aisle.locations?.items || []).forEach((location) => {
        trackIds.push(location.id);
      });
    });
    return trackIds;
  };

  const removeAreaZonesLocations = async (area) => {
    if (!area) return;

    let isOnTrack, isStored, isUnloaded, isReview, isShipped, isHeld;
    let results;
    debugger;

    let logLocation =
      "reloadYard:Areas:removeAreaZonesLocations:countInventories";
    try {
      setLoading(true);
      setDeleteOpen(false);

      if (area.areaType === AreaType.TRACK) {
        const trackIds = collectAreaTrackLocationIds(area);
        isOnTrack = await hasTrackCarsOnLocations(trackIds);
      } else {
        debugger;
        const searchQuery = {
          areaId: area.id,
          status: { beginsWith: InventoryStatus.STORED },
          limit: 1,
        };

        results = await API.graphql(
          graphqlOperation(inventoryItemByAreaByStatusMini, searchQuery)
        );
        isStored = results.data.inventoryItemByAreaByStatus.items.length > 0;

        if (!isStored) {
          searchQuery.status.beginsWith = InventoryStatus.UNLOADED;
          results = await API.graphql(
            graphqlOperation(inventoryItemByAreaByStatusMini, searchQuery)
          );
          isUnloaded =
            results.data.inventoryItemByAreaByStatus.items.length > 0;
        }

        if (!isStored && !isUnloaded) {
          searchQuery.status.beginsWith = InventoryStatus.REVIEW;
          results = await API.graphql(
            graphqlOperation(inventoryItemByAreaByStatusMini, searchQuery)
          );
          isReview = results.data.inventoryItemByAreaByStatus.items.length > 0;
        }

        isHeld = isStored || isUnloaded || isReview;
        if (!isHeld) {
          searchQuery.status.beginsWith = InventoryStatus.SHIPPED;
          results = await API.graphql(
            graphqlOperation(inventoryItemByAreaByStatusMini, searchQuery)
          );
          isShipped = results.data.inventoryItemByAreaByStatus.items.length > 0;
        }
      }

      debugger;
      if (isHeld) {
        notify("Area has Locations that are in use!", "warning");
        return Promise.resolve();
      } else if (isOnTrack) {
        notify("Tracks contain placed railcars!", "warning");
        return Promise.resolve();
      } else if (isShipped) {
        debugger;
        logLocation = "reloadYard:Areas:removeAreaZonesLocations:updateArea";
        area.active = "false";
        await doUpdateArea(area);

        // XXXXXXXXXX
        const toUpdateZones = area.zones.items;
        toUpdateZones.forEach((zone) => (zone.active = "false"));
        await doUpdateZones(toUpdateZones);

        const toUpdateAisles = aisles.filter(
          (aisle) => aisle.areaId === area.id
        );
        toUpdateAisles.forEach((aisle) => (aisle.active = "false"));
        await doUpdateAisles(toUpdateAisles);

        const toUpdateLocations = [];
        for (const aisle of toUpdateAisles) {
          if (aisle.locations.nextToken) {
            const response = await API.graphql(
              graphqlOperation(locationByAisleBySortKey, {
                aisleId: aisle.id,
                limit: 1000,
              })
            );
            const activeLocations =
              response.data.locationByAisleBySortKey.items.filter(
                (itm) => itm.active === "true"
              );
            toUpdateLocations.push(...activeLocations);
          } else {
            toUpdateLocations.push(...aisle.locations.items);
          }
        }
        toUpdateLocations.forEach((location) => {
          location.active = "false";
          location.productId = location.productId ? location.productId : "";
        });
        await doUpdateLocations(toUpdateLocations);

        const newAreas = areas.filter((itm) => itm.id !== area.id);
        newAreas.forEach((itm, idx) => (itm.sortKey = idx));
        await doUpdateAreas(newAreas);
        notify("Area deleted succesfully.", "info");
      } else {
        await doDeleteLocations(area.id);
        await doDeleteAisles(area.id);
        await doDeleteZones(area.zones.items);
        await doDeleteArea(area);

        const newAreas = areas.filter((itm) => itm.id !== area.id);
        newAreas.forEach((itm, idx) => (itm.sortKey = idx));
        await doUpdateAreas(newAreas);
        notify("Area deleted succesfully.", "info");
      }

      getData();
    } catch (error) {
      logError(logLocation, error, notify);
    } finally {
      setLoading(false);
      setSelectedArea(null);
      setDeleteOpen(false);
    }
  };

  const allowDrop = (evt) => {
    evt.preventDefault();
  };

  const drag = (evt, zone) => {
    evt.dataTransfer.setData("data", zone.id);
  };

  const drop = async (evt, toZone) => {
    try {
      setLoading(true);
      debugger;
      const toIdx = areas.findIndex((itm) => itm.id === toZone.id);
      const fromAreaId = evt.dataTransfer.getData("data");
      const fromIdx = areas.findIndex((itm) => itm.id === fromAreaId);
      const fromArea = areas[fromIdx];
      evt.preventDefault();

      areas.splice(fromIdx, 1);
      areas.splice(toIdx, 0, fromArea);
      areas.forEach((itm, idx) => (itm.sortKey = idx));

      debugger;
      await doUpdateAreas(areas);
      notify("Area updated succesfully.", "info");
      getData();
    } catch (err) {
      logError("reloadYard:Areas:drop", err, notify);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      }
      <div>
        <div className={classes.addContainer}>
          <Button
            onClick={() => setAddOpen(true)}
            color="primary"
            variant="outlined"
            startIcon={<AddIcon />}
          >
            Add Area
          </Button>
        </div>
        <List component="nav">
          {areas.map((area) => (
            <div key={area.id}>
              <ListItem>
                <ListItemAvatar>
                  <Avatar
                    style={{
                      backgroundColor: area.color ? area.color : "81C784",
                    }}
                    draggable="true"
                    onDragStart={(evt) => drag(evt, area)}
                    onDragOver={(evt) => allowDrop(evt)}
                    onDrop={(evt) => drop(evt, area)}
                    className={classes.avatar}
                  >
                    <LocationOnIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={area.name} />
                <ListItemSecondaryAction>
                  <IconButton edge="end" onClick={() => openRenameDialog(area)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    edge="end"
                    onClick={() => handleDeleteArea(area)}
                    disabled={disableDelete()}
                  >
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
              <Divider variant="inset" component="li" />
            </div>
          ))}
        </List>
      </div>
      <Dialog open={deleteOpen}>
        <DialogTitle id="delete-area">Delete Area</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Warning, deleting an Area will delete all Zones and Locations within
            that area.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setDeleteOpen(false)}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            onClick={() => removeAreaZonesLocations(selectedArea)}
            color="primary"
            autoFocus
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <AreaDialog
        area={selectedArea}
        areas={areas}
        open={renameOpen}
        handleCancel={() => setRenameOpen(false)}
        handleClose={renameArea}
        title="Rename Area"
      />
      <AreaDialog
        area={{}}
        areas={areas}
        open={addOpen}
        handleCancel={() => setAddOpen(false)}
        handleClose={addArea}
        title="Create Area"
      />
    </>
  );
};

const AreaDialog = ({
  title,
  area,
  areas,
  open,
  handleClose,
  handleCancel,
}) => {
  const [selectedArea, setSelectedArea] = useState();
  const [error, setError] = useState({});

  useEffect(() => {
    setSelectedArea(area ? { ...area } : {});
  }, [area]);

  const setAreaName = (name) => {
    setSelectedArea({ ...selectedArea, name });
  };

  const setAreaPrefix = (prefix) => {
    setSelectedArea({ ...selectedArea, prefix: prefix.toUpperCase() });
  };

  const setAreaType = (value) => {
    setSelectedArea({ ...selectedArea, areaType: value });
  };

  const validateForm = () => {
    debugger;
    let hasError = false;
    const error = {};

    if (!selectedArea.name) {
      error.name = "Area name is required";
      hasError = true;
    }
    let existingArea = areas.find(
      (itm) =>
        itm.id !== selectedArea.id &&
        itm.name?.toUpperCase() === selectedArea.name?.toUpperCase()
    );
    if (existingArea) {
      error.name = "Duplicate area name";
      hasError = true;
    }
    if (!selectedArea.prefix) {
      error.prefix = "Area prefix is required";
      hasError = true;
    } else if (!selectedArea.prefix || selectedArea.prefix.length > 2) {
      error.prefix = "Area prefix max. length two characters";
      hasError = true;
    } else {
      existingArea = areas.find(
        (itm) =>
          itm.id !== selectedArea.id &&
          itm.prefix?.toUpperCase() === selectedArea.prefix?.toUpperCase()
      );
      if (existingArea) {
        error.prefix = "Duplicate area prefix";
        hasError = true;
      }
    }
    if (!selectedArea.areaType) {
      error.areaType = "Area Type is required";
      hasError = true;
    } else if (selectedArea.areaType === AreaType.TRACK) {
      if (areas.some((itm) => itm.areaType === AreaType.TRACK)) {
        error.areaType = "Only one Track area is allowed.";
        hasError = true;
      }
    }

    setError(error);
    return hasError;
  };

  const handleSubmit = (evt) => {
    if (evt.preventDefault) evt.preventDefault();
    const hasError = validateForm();
    if (!hasError) handleClose(selectedArea);
  };

  return (
    <Dialog open={open} onClose={handleCancel}>
      <DialogTitle>{title}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            autoFocus
            id="name"
            label="Area name"
            margin="dense"
            variant="outlined"
            fullWidth
            required
            value={selectedArea ? selectedArea.name : ""}
            onChange={(evt) => setAreaName(evt.target.value)}
            error={error.name}
            helperText={error.name ? error.name : ""}
          />
          <TextField
            id="prefix"
            label="Area prefix"
            margin="dense"
            variant="outlined"
            fullWidth
            required
            value={selectedArea ? selectedArea.prefix : ""}
            onChange={(evt) => setAreaPrefix(evt.target.value)}
            error={error.prefix}
            helperText={error.prefix ? error.prefix : ""}
            inputProps={{ maxLength: 2, style: { textTransform: "uppercase" } }}
          />
          <TextField
            select
            id="areaType"
            name="areaType"
            label="Area Type"
            margin="dense"
            variant="outlined"
            fullWidth
            required
            disabled={selectedArea?.id}
            value={selectedArea ? selectedArea.areaType : ""}
            onChange={(evt) => setAreaType(evt.target.value)}
            error={error.areaType}
            helperText={error.areaType ? error.areaType : ""}
          >
            {AreaTypeOptions.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}> Cancel </Button>
          <Button type="submit" color="primary" onClick={handleSubmit}>
            {" "}
            Submit{" "}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default Areas;
